import Api from '../api'

export default ({
  state: {
    fixedAssetsMaxPurchaseNumber: null,
    fixedAssetsMaxPurchaseChallanNumber: null,
    fixedAssetsMaxPurchaseOrderNumber: null,
    fixedAssetsMaxSalesReturnNumber: null,
    fixedAssetsPurchaseChallanLists: [],
    fixedAssetsPurchaseInvoiceLists: [],
    fixedAssetsPurchaseOrderLists: [],
    fixedAssetsPurchaseReturnLists: [],
    fixedAssetsInventoryInDetailList: []
  },
  mutations: {
    FIXEDASSETS_MAX_PURCHASE_NUMBER(state, fixedAssetsMaxPurchaseNo) {
      state.fixedAssetsMaxPurchaseNumber = fixedAssetsMaxPurchaseNo
    },
    FIXEDASSETS_MAX_PURCHASE_CHALLAN_NUMBER(state, fixedAssetsMaxPurchaseChallanNo) {
      state.fixedAssetsMaxPurchaseChallanNumber = fixedAssetsMaxPurchaseChallanNo
    },
    FIXEDASSETS_MAX_SALES_RETURN_NUMBER(state, fixedAssetsMaxSalesReturnNo) {
      state.fixedAssetsMaxSalesReturnNumber = fixedAssetsMaxSalesReturnNo
    },
    FIXEDASSETS_MAX_PURCHASE_ORDER_NUMBER(state, fixedAssetsMaxPurchaseOrderNo) {
      state.fixedAssetsMaxPurchaseOrderNumber = fixedAssetsMaxPurchaseOrderNo
    },
    FIXEDASSETS_PURCHASE_CHALLAN_LIST(state, fixedAssetsPurchaseChallanList) {
      state.fixedAssetsPurchaseChallanLists = fixedAssetsPurchaseChallanList
    },
    FIXEDASSETS_PURCHASE_INVOICE_LIST(state, fixedAssetsPurchaseInvoiceList) {
      state.fixedAssetsPurchaseInvoiceLists = fixedAssetsPurchaseInvoiceList
    },
    FIXEDASSETS_PURCHASE_ORDER_LIST(state, fixedAssetsPurchaseOrderList) {
      state.fixedAssetsPurchaseOrderLists = fixedAssetsPurchaseOrderList
    },
    FIXEDASSETS_PURCHASE_RETURN_LIST(state, fixedAssetsPurchaseReturnList) {
      state.fixedAssetsPurchaseReturnLists = fixedAssetsPurchaseReturnList
    },
    FIXEDASSETS_DELETE_PURCHASE_RETURN(state, inventoryInHeaderId) {
      let fixedAssetsPurchaseReturnList = state.fixedAssetsPurchaseReturnLists.filter(a => a.id !== inventoryInHeaderId.id)
      state.fixedAssetsPurchaseReturnLists = fixedAssetsPurchaseReturnList
    },
    FIXEDASSETS_DELETE_PURCHASE_INVOICE(state, purInvoice) {
      let fixedAssetsPurchaseInvoiceList = state.fixedAssetsPurchaseInvoiceLists.filter(a => a.id !== purInvoice.id)
      state.fixedAssetsPurchaseInvoiceLists = fixedAssetsPurchaseInvoiceList
    },
    FIXEDASSETS_DELETE_PURCHASE_ORDER(state, purOrder) {
      let fixedAssetsPurchaseOrderList = state.fixedAssetsPurchaseOrderLists.filter(a => a.id !== purOrder.id)
      state.fixedAssetsPurchaseOrderLists = fixedAssetsPurchaseOrderList
    },
    FIXEDASSETS_DELETE_PURCHASE_CHALLAN(state, purChallan) {
      let fixedAssetsPurchaseChallanList = state.fixedAssetsPurchaseChallanLists.filter(a => a.id !== purChallan.id)
      state.fixedAssetsPurchaseChallanLists = fixedAssetsPurchaseChallanList
    },
    FIXEDASSETS_UPDATE_PURCHASE_CHALLAN(state, updatedfixedAssetsPurChallan) {
      let fixedAssetsPurchaseChallan = state.fixedAssetsPurchaseChallanLists.map(so => so.id !== updatedfixedAssetsPurChallan.id ? so : { ...so, ...updatedfixedAssetsPurChallan })
      state.fixedAssetsPurchaseChallanLists = fixedAssetsPurchaseChallan
    },
    FIXEDASSETS_INVENTORY_IN_DETAIL(state, inventoryInDetail) {
      state.fixedAssetsInventoryInDetailList = inventoryInDetail
    },
    FIXEDASSETS_UPDATE_PURCHASE_INVOICE(state, updatedfixedAssetsPurchaseInv) {
      state.fixedAssetsPurchaseInvoiceLists = state.fixedAssetsPurchaseInvoiceLists.map(purchaseInv => purchaseInv.id !== updatedfixedAssetsPurchaseInv.id ? purchaseInv : { ...purchaseInv, ...updatedfixedAssetsPurchaseInv })
    },
    FIXEDASSETS_UPDATE_PURCHASE_RETURN(state, fixedAssetsPurchaseReturn) {
      state.fixedAssetsPurchaseReturnLists = state.fixedAssetsPurchaseReturnLists.map(purRetr => purRetr.id !== fixedAssetsPurchaseReturn.id ? purRetr : { ...purRetr, ...fixedAssetsPurchaseReturn })
    },
    FIXEDASSETS_UPDATE_PURCHASE_ORDER(state, fixedAssetsPurchaseOrder) {
      state.fixedAssetsPurchaseOrderLists = state.fixedAssetsPurchaseOrderLists.map(purOrd => purOrd.id !== fixedAssetsPurchaseOrder.id ? purOrd : { ...purOrd, ...fixedAssetsPurchaseOrder })
    }
  },
  actions: {
    async loadfixedAssetsMaxPurchaseOrderNo({ commit }) {
      let response = await Api.request('get', '/fixedAssets/purchaseOrderLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('FIXEDASSETS_MAX_PURCHASE_ORDER_NUMBER', responseValue)
      return response
    },
    async fixedAssetsMaxPurchaseBillNo({ commit }) {
      let response = await Api.request('get', '/fixedAssets/purchaseInvoiceLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('FIXEDASSETS_MAX_PURCHASE_NUMBER', responseValue)
      return response
    },
    async fixedAssetsMaxPurchaseChallanNumber({ commit }) {
      let response = await Api.request('get', '/fixedAssets/purchaseChallanLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('FIXEDASSETS_MAX_PURCHASE_CHALLAN_NUMBER', responseValue)
      return response
    },
    async fixedAssetsMaxSalesReturnNumber({ commit }) {
      let response = await Api.request('get', '/fixedAssets/salesReturnLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('FIXEDASSETS_MAX_SALES_RETURN_NUMBER', responseValue)
      return response
    },
    async addFixedAssetsPurchaseOrder({ commit }, purchaseOrder) {
      let response = await Api.request('post', '/fixedAssets/purchaseOrder/' + this.state.organisationid + '/' + this.state.user.id, purchaseOrder)
      let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('FIXEDASSETS_ADD_PURCHASE_ORDER', responseValue)
      }
      return response
    },
    async fixedAssetsSalesReturn({ commit }, salesReturn) {
      let response = await Api.request('post', '/fixedAssets/saveSalesReturn/' + this.state.organisationid + '/' + this.state.user.id, salesReturn)
      let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('FIXEDASSETS_ADD_SALES_RETURN', responseValue)
      }
      return response
    },
    async updateFixedAssetsSalesReturn({ commit }, updateSalesReturn) {
      let response = await Api.request('put', '/fixedAssets/updatePurchase/' + updateSalesReturn.inventoryOutHeaderId + '/' + this.getters.userId, updateSalesReturn)
      if (response.data.status === 'SUCCESS') {
        commit('FIXEDASSETS_UPDATE_SALES_RETURN', response.data.data)
      }
      return response
    },
    async addFixedAssetspurchaseChallan({ commit }, purchaseChallan) {
      let response = await Api.request('post', '/fixedAssets/purchaseChallan/' + this.state.organisationid + '/' + this.state.user.id, purchaseChallan)
      let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('FIXEDASSETS_ADD_PURCHASE_CHALLAN', responseValue)
      }
      return response
    },
    async addFixedAssetsPurchaseInvoice({ commit }, purchaseInvoice) {
      let response = await Api.request('post', '/fixedAssets/purchaseInvoice/' + this.state.organisationid + '/' + this.state.user.id, purchaseInvoice)
      let responseValue = response.data.data
      if (response.data.data === 'SUCCESS') {
        commit('FIXEDASSETS_ADD_PURCHASE_INVOICE', responseValue)
      }
      return response
    },
    async addFixedAssetsUpdatePurchaseOrder({ commit }, updatePurchaseInv) {
      let response = await Api.request('put', '/fixedAssets/updatePurchase/' + updatePurchaseInv.inventoryHeaderId + '/' + this.state.user.id, updatePurchaseInv)
      commit('FIXEDASSETS_UPDATE_PURCHASE_ORDER', response.data.data)
      return response
    },
    async updateFixedAssetsPurchaseChallan({ commit }, updatePurchaseInv) {
      let response = await Api.request('put', '/fixedAssets/updatePurchase/' + updatePurchaseInv.inventoryHeaderId + '/' + this.state.user.id, updatePurchaseInv)
      commit('FIXEDASSETS_UPDATE_PURCHASE_CHALLAN', response.data.data)
      return response
    },
    async updateFixedAssetsPurchaseInvoice({ commit }, updatePurchaseInv) {
      let response = await Api.request('put', '/fixedAssets/updatePurchase/' + updatePurchaseInv.inventoryHeaderId + '/' + this.state.user.id, updatePurchaseInv)
      commit('FIXEDASSETS_UPDATE_PURCHASE_INVOICE', response.data.data)
      return response
    },
    async updateFixedAssetsPurchaseReturn({ commit }, updatePurchaseInv) {
      let response = await Api.request('put', '/fixedAssets/updatePurchase/' + updatePurchaseInv.inventoryHeaderId + '/' + this.state.user.id, updatePurchaseInv)
      commit('FIXEDASSETS_UPDATE_PURCHASE_RETURN', response.data.data)
      return response
    },
    async loadFixedAssetsPurchaseOrderLists({ commit }, date) {
      let response = await Api.request('get', '/fixedAssetsReport/purchaseOrder/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('FIXEDASSETS_PURCHASE_ORDER_LIST', responseValue)
      return response
    },
    async loadFixedAssetsPurchaseInvoiceLists({ commit }, date) {
      let response = await Api.request('get', '/fixedAssetsReport/purchaseInvoice/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('FIXEDASSETS_PURCHASE_INVOICE_LIST', responseValue)
      return response
    },
    async loadFApurchaseChallanLists({ commit }, date) {
      let response = await Api.request('get', '/fixedAssetsReport/purchaseChallan/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('FIXEDASSETS_PURCHASE_CHALLAN_LIST', responseValue)
      return response
    },
    async deleteFAPurchaseOrder({ commit }, deleteRea) {
      let response = await Api.request('delete', '/fixedAssets/deletePurchase/' + deleteRea.inventoryInHeaderId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let deletePurchase = response.data.data
      commit('FIXEDASSETS_DELETE_PURCHASE_ORDER', deletePurchase)
      return response
    },
    async deleteFAPurchaseChallan({ commit }, deleteRea) {
      let response = await Api.request('delete', '/fixedAssets/deletePurchase/' + deleteRea.inventoryInHeaderId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let deletePurchase = response.data.data
      commit('FIXEDASSETS_DELETE_PURCHASE_CHALLAN', deletePurchase)
      return response
    },
    async deleteFAPurchaseInvoice({ commit }, deleteRea) {
      let response = await Api.request('delete', '/fixedAssets/deletePurchase/' + deleteRea.inventoryInHeaderId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let deletePurchase = response.data.data
      commit('FIXEDASSETS_DELETE_PURCHASE_INVOICE', deletePurchase)
      return response
    },
    async deleteFAPurchaseReturn({ commit }, deleteRea) {
      let response = await Api.request('delete', '/fixedAssets/deletePurchase/' + deleteRea.inventoryInHeaderId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let deletePurchase = response.data.data
      commit('FIXEDASSETS_DELETE_PURCHASE_RETURN', deletePurchase)
      return response
    },
    async loadFixedAssetsInventoryDetail({ commit }, id) {
      let response = await Api.request('get', '/fixedAssetsReport/inventoryInDetail/' + this.getters.organisationId + '/' + this.state.user.id + '/' + id)
      if (response.data.status === 'SUCCESS') {
        commit('FIXEDASSETS_INVENTORY_IN_DETAIL', response.data.data)
      }
      return response
    },
    async loadFixedAssetPurchaseReturnLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/purchaseReturn/' + this.getters.organisationId + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate)
      let responseValue = response.data.data
      commit('FIXEDASSETS_PURCHASE_RETURN_LIST', responseValue)
      return response
    },
    async exportFAFileData({ commit }, data) {
      let response = await Api.request('get', '/fixedAssets/excelReport/' + this.getters.organisationId + '/' + this.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/purchaseOrder')
      return response
    },
    async extraExpensesFixedAssetsPurchaseList({ commit }, inventoryHeaderId) {
      let response = await Api.request('get', '/fixedAssetsReport/extraExpensesList/' + inventoryHeaderId + '/' + 'purchaseInvoice')
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async fixedAssetsPurchaseBillNumber({ commit }) {
      let response = await Api.request('get', '/fixedAssets/billNumber/' + this.getters.organisationId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadFAOrderIdList({ commit }) {
      let response = await Api.request('get', '/fixedAssets/orderNumber/' + this.getters.organisationId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async faChallanIdList({ commit }) {
      let response = await Api.request('get', '/fixedAssets/challanNumbers/' + this.getters.organisationId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async fixedAssetsInventoryDetailsByBillNo({ commit }, billNo) {
      let response = await Api.request('get', '/fixedAssetsReport/purchaseDetailsByBillNo/' + billNo + '/' + this.getters.organisationId + '/' + this.getters.userId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async fixedAssetsPurchaseReturnBillWise({ commit }, returnData) {
      let response = await Api.request('post', '/fixedAssetsReportInventoryOut/purchaseReturn/' + returnData.inventoryHeaderId + '/' + this.getters.organisationId + '/' + this.getters.userId, returnData)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    // async addPrint({ commit }, prinTData) {
    //   let response = await Api.request('post', '/fileDownload/savePrintPos/' + this.state.organisationid + '/' + this.state.user.id, prinTData)
    //   let responseValue = response.data.data
    //   if (response.data.data === 'SUCCESS') {
    //     commit('ADD_PRINT', responseValue)
    //   }
    //   return response
    // },
    async loadDataWithFixedAssetesOrderId({commit}, orderId) {
      let response = await Api.request('get', '/fixedAssetsReport/purchaseDetailsByOrderNo/' + orderId + '/' + this.state.organisationid + '/' + this.state.user.id)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadDataWithFixedAssetsPurchaseChallanNo({commit}, challanNo) {
      let response = await Api.request('get', '/fixedAssetsReport/purchaseDetailsByChallanNo/' + challanNo + '/' + this.state.organisationid + '/' + this.state.user.id)
      if (response.data.statue === 'SUCCESS') {
        return response
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/fixedAssetsPurchase.js